import type { Lang } from '../prefs.tsx';

const ru = {
  navLabel: 'Основная навигация',
  navProduct: 'Возможности',
  navPricing: 'Цены',
  navFaq: 'Вопросы',
  signIn: 'Войти',
  getStarted: 'Начать',
  telegram: 'Telegram',
  telegramCta: 'Открыть Uplink в Telegram',
  telegramCtaHint: 'Без отдельного пароля — Telegram авторизует вас автоматически.',
  trialCta: 'Попробовать VPN бесплатно',
  trialHint: '24 часа · 10 ГБ · до 2 устройств · без оплаты',
  languageLabel: 'Переключить язык на английский',
  languageShort: 'EN',
  heroTitle: (
    <>
      Домены, серверы
      <br />и собственный VPN
    </>
  ),
  heroText:
    'Зарегистрируйте домен в 785 зонах, запустите сервер в одном из 28 городов и получите ключ VPN за несколько минут. Единый баланс — в браузере и Telegram.',
  domainSearch: 'Поиск домена',
  domainName: 'Доменное имя',
  domainPlaceholder: 'Найдите свой домен',
  search: 'Найти',
  checking: 'Проверяем доступность…',
  renews: (price: string) => `продление ${price}`,
  buy: 'Купить',
  premium: 'Премиум',
  taken: 'Занят',
  nothingFound: 'Ничего не найдено. Попробуйте другое имя.',
  domainFrom: (price: string) => `от ${price} в год`,
  factsLabel: 'Uplink в цифрах',
  facts: [
    ['785', 'доменных зон'],
    ['28', 'городов с серверами в 18 странах'],
    ['4', 'VPN-протокола с автоматической установкой'],
    ['1 мин', 'до регистрации домена'],
  ],
  productTitle: 'Uplink - облачная платформа для ваших проектов.',
  productLede: 'Домен, облачный сервер и свой VPN на собственном сервере с оплатой с единого баланса.',
  available: 'Свободен',
  domainsTitle: 'Домены в 785 зонах',
  domainsText: 'Найдите и купите домен за минуту, настройте DNS и направьте его на сервер одной кнопкой.',
  vpnTitle: 'Свой VPN на отдельном сервере',
  vpnText: 'Не место в общем VPN-сервисе: сервер, стабильный IP и панель управления принадлежат только вам.',
  citiesTitle: 'Серверы в 28 городах',
  citiesText: 'Root-доступ к Ubuntu или Debian, готовность за несколько минут и помесячная оплата.',
  cityNames: ['Франкфурт', 'Амстердам', 'Нью-Йорк', 'Сингапур', 'Стокгольм', 'Токио'],
  monitoringTitle: 'Мониторинг в реальном времени',
  monitoringText:
    'Одна команда установит агент. Графики появятся через минуту, а уведомления придут в Telegram.',
  telegramTitle: 'Тот же аккаунт в Telegram',
  telegramText: 'Бот и Mini App показывают тот же баланс, домены и серверы, что и сайт.',
  vpnBenefitsTitle: 'Не общий VPN. Свой сервер.',
  vpnBenefitsLede:
    'Uplink автоматически установит и настроит VPN, но сервер, IP и ключи будут только вашими. Именно этим свой VPN отличается от обычной подписки.',
  vpnBenefits: [
    [
      'Личный IP без «соседей»',
      'IP не делят сотни посторонних пользователей — меньше CAPTCHA и случайных блокировок сервисами.',
    ],
    [
      'Один стабильный адрес',
      'Добавляйте IP в белые списки админок, SSH, API, баз данных и корпоративных систем.',
    ],
    ['Ресурсы только ваши', 'Скорость сервера не забирают незнакомые пользователи общего VPN-сервиса.'],
    [
      'Ключ для каждого',
      'Создавайте отдельные ключи для семьи, команды, телефонов, ноутбуков и телевизоров.',
    ],
    [
      'Панель под вашим контролем',
      'Самостоятельно добавляйте и отключайте ключи, следите за подключениями и трафиком.',
    ],
    [
      'Сервер остаётся сервером',
      'Используйте root-доступ для сайта, бота, API, мониторинга, прокси или среды разработки.',
    ],
  ],
  trialTitle: 'Проверьте работу из России до оплаты',
  trialText:
    'Получите личный VLESS-ключ на 24 часа и проверьте скорость, Telegram, YouTube и другие сервисы на своём устройстве и у своего провайдера.',
  trialAction: 'Получить бесплатный ключ',
  serverReady: 'Сервер web-prod готов',
  serverPassword: 'IP 203.0.113.24 · пароль root в приложении',
  openServer: 'Открыть сервер',
  stepsTitle: 'Запуск в три шага',
  stepsLede: 'Без документов, банковских карт и ожидания менеджера.',
  steps: [
    ['Создайте аккаунт', 'По email или сразу через Telegram в одно нажатие.'],
    ['Пополните баланс криптовалютой', 'USDT, TON, BTC и другие валюты через @CryptoBot или @xRocket.'],
    ['Запускайте', 'Купите домен или создайте сервер — всё будет готово за несколько минут.'],
  ],
  pricingTitle: 'Простые цены',
  pricingLede:
    'Платите только за используемые услуги. Без платы за подключение и договоров, баланс хранится в долларах США.',
  from: 'от',
  perYear: 'год',
  perMonth: 'месяц',
  plans: {
    vpnGroupName: 'VPN',
    domains: {
      name: 'Домены',
      items: [
        '785 зон, цена продления известна заранее',
        'Редактор DNS и автопродление',
        'Код переноса в любое время',
      ],
      cta: 'Найти домен',
    },
    servers: {
      name: 'Серверы',
      items: [
        '28 городов в 18 странах',
        'Root-доступ, Ubuntu или Debian',
        'Мониторинг и уведомления включены',
      ],
      cta: 'Создать сервер',
    },
    sharedVpn: {
      name: 'VPN-доступ',
      items: [
        'Готовый VLESS-ключ без настройки сервера',
        'До 2 устройств и 100 ГБ на 30 дней',
        'Работает из России — можно проверить бесплатно',
      ],
      cta: 'Купить VPN-доступ',
    },
    vpn: {
      name: 'Свой VPN',
      badge: '24 часа бесплатно',
      items: [
        'Отдельный сервер и стабильный IP только для вас',
        'VLESS Reality для работы в условиях блокировок',
        'Своя панель и отдельные ключи для семьи или команды',
      ],
      cta: 'Попробовать бесплатно',
      secondaryCta: 'Создать свой VPN',
    },
  },
  questions: 'Вопросы',
  faq: [
    [
      'Как оплатить?',
      'Пополните баланс криптовалютой через @CryptoBot или @xRocket: USDT, TON, BTC, ETH, LTC или TRX. Обычно деньги зачисляются автоматически в течение минуты.',
    ],
    [
      'Кому принадлежит домен?',
      'Вы управляете доменом из своего аккаунта: настраиваете DNS и продление, а при необходимости получаете код переноса к другому регистратору.',
    ],
    [
      'Какой VPN выбрать?',
      'VLESS Reality лучше подходит там, где VPN блокируют. AmneziaWG быстрый и маскирует трафик, Outline проще всего настроить, а WireGuard подходит для стран без блокировок.',
    ],
    [
      'Можно ли проверить VPN перед покупкой?',
      'Да. После регистрации вы получите личный VLESS-ключ на 24 часа с лимитом 10 ГБ и сможете подключить до двух устройств. Затем проверьте скорость и доступность сервисов на публичной странице VPN-статуса.',
    ],
    [
      'Чем свой VPN отличается от обычного VPN-сервиса?',
      'Обычный VPN продаёт доступ к общей инфраструктуре, где один IP и ресурсы делят многие люди. В Uplink вы получаете отдельный облачный сервер со стабильным IP и собственной панелью. Вы сами управляете ключами, а трафик не проходит через общую VPN-инфраструктуру Uplink.',
    ],
    [
      'Работает ли VPN из России?',
      'Для стран с блокировками мы предлагаем VLESS Reality, который маскируется под обычный HTTPS-трафик. На странице статуса мы показываем результат последней подтверждённой проверки VPN. Перед покупкой можно получить бесплатный ключ на 24 часа и проверить работу у своего российского провайдера.',
    ],
    [
      'Можно ли подключить семью или команду?',
      'Да. В своей панели можно создать отдельные ключи для разных людей и устройств. Фактическое количество одновременных подключений зависит от мощности сервера и нагрузки.',
    ],
    [
      'Что будет, если закончатся деньги?',
      'Мы предупредим заранее. Неоплаченный сервер остановится и будет удалён ещё через три дня; пополнение баланса вернёт его в работу.',
    ],
    [
      'Можно пользоваться сайтом и Telegram?',
      'Да. Привяжите Telegram в профиле — это будет один аккаунт с общим балансом, доменами и серверами в браузере, боте и Mini App.',
    ],
  ],
  ctaTitle: 'Начните за минуту',
  ctaText: 'Создайте аккаунт, пополните баланс и запустите первый домен, сервер или VPN уже сегодня.',
  createAccount: 'Создать аккаунт',
  openTelegram: 'Открыть в Telegram',
  footer: 'Домены, серверы и VPN · оплата криптовалютой через @CryptoBot и @xRocket',
  dashboard: {
    home: 'Главная',
    domains: 'Домены',
    servers: 'Серверы',
    balance: 'Баланс',
    profile: 'Профиль',
    greeting: 'Добрый вечер, Анна',
    topUp: 'Пополнить',
    monthly: '$18.59 в месяц · хватит до марта',
    cpu: 'ЦП · web-prod',
    vpnReady: 'VPN готов',
    renews: 'Продление 14 мая 2027',
    autoRenew: 'Автопродление включено',
    frankfurt: 'Франкфурт',
    amsterdam: 'Амстердам',
  },
};

const en: typeof ru = {
  navLabel: 'Main navigation',
  navProduct: 'Product',
  navPricing: 'Pricing',
  navFaq: 'FAQ',
  signIn: 'Sign in',
  getStarted: 'Get started',
  telegram: 'Telegram',
  telegramCta: 'Open Uplink in Telegram',
  telegramCtaHint: 'No separate password — Telegram signs you in automatically.',
  trialCta: 'Try VPN for free',
  trialHint: '24 hours · 10 GB · up to 2 devices · no payment',
  languageLabel: 'Переключить язык на русский',
  languageShort: 'RU',
  heroTitle: (
    <>
      Domains, servers
      <br />
      and your own VPN
    </>
  ),
  heroText:
    'Register a domain in 785 zones, launch a server in 28 cities and get a VPN key in minutes. One balance, in your browser and in Telegram.',
  domainSearch: 'Domain search',
  domainName: 'Domain name',
  domainPlaceholder: 'Find your domain',
  search: 'Search',
  checking: 'Checking availability…',
  renews: (price) => `renews ${price}`,
  buy: 'Buy',
  premium: 'Premium',
  taken: 'Taken',
  nothingFound: 'Nothing found. Try another name.',
  domainFrom: (price) => `from ${price} a year`,
  factsLabel: 'Uplink in numbers',
  facts: [
    ['785', 'domain zones'],
    ['28', 'server cities in 18 countries'],
    ['4', 'VPN protocols, installed for you'],
    ['1 min', 'to a registered domain'],
  ],
  productTitle: 'One platform, from a domain to a personal VPN',
  productLede: 'A domain, a cloud server and a VPN on your own infrastructure, paid from one balance.',
  available: 'Available',
  domainsTitle: 'Domains in 785 zones',
  domainsText: 'Search, buy in a minute, edit DNS and point the domain at your server with one button.',
  vpnTitle: 'A personal VPN on a separate server',
  vpnText: 'Not a seat on a shared VPN service: the server, stable IP and control panel are yours alone.',
  citiesTitle: 'Servers in 28 cities',
  citiesText: 'Root access on Ubuntu or Debian, ready in a couple of minutes, billed monthly.',
  cityNames: ['Frankfurt', 'Amsterdam', 'New York', 'Singapore', 'Stockholm', 'Tokyo'],
  monitoringTitle: 'Live monitoring',
  monitoringText: 'One command installs the agent. Charts appear in a minute, alerts come to Telegram.',
  telegramTitle: 'The same account in Telegram',
  telegramText: 'The bot and its Mini App show the same balance, domains and servers as the website.',
  vpnBenefitsTitle: 'Not a shared VPN. Your personal server.',
  vpnBenefitsLede:
    'Uplink installs and configures the VPN, while the server, IP and keys remain yours alone. That is what makes it different from a regular VPN subscription.',
  vpnBenefits: [
    [
      'A personal IP without strangers',
      'Hundreds of unrelated users do not share it, reducing CAPTCHAs and accidental service blocks.',
    ],
    ['One stable address', 'Allowlist the IP for admin panels, SSH, APIs, databases and corporate systems.'],
    [
      'Resources reserved for you',
      'Strangers on a shared VPN service cannot consume your server performance.',
    ],
    ['A key for everyone', 'Create separate keys for family, team members, phones, laptops and TVs.'],
    ['A panel under your control', 'Add and revoke keys yourself and inspect connections and traffic.'],
    [
      'Still a full server',
      'Use root access for a website, bot, API, monitoring, proxy or development environment.',
    ],
  ],
  trialTitle: 'Test it from Russia before paying',
  trialText:
    'Get a personal VLESS key for 24 hours and test speed, Telegram, YouTube and other services on your device and internet provider.',
  trialAction: 'Get a free key',
  serverReady: 'Server web-prod is ready',
  serverPassword: 'IP 203.0.113.24 · root password in the app',
  openServer: 'Open the server',
  stepsTitle: 'Live in three steps',
  stepsLede: 'No paperwork, no cards, no waiting for a manager.',
  steps: [
    ['Create an account', 'With an email or straight from Telegram in one tap.'],
    ['Top up in crypto', 'USDT, TON, BTC and more through @CryptoBot or @xRocket.'],
    ['Launch', 'Buy a domain or start a server. It is ready in minutes.'],
  ],
  pricingTitle: 'Simple pricing',
  pricingLede: 'Pay only for what you run. No setup fees, no contracts, the balance is kept in US dollars.',
  from: 'from',
  perYear: 'year',
  perMonth: 'month',
  plans: {
    vpnGroupName: 'VPN',
    domains: {
      name: 'Domains',
      items: [
        '785 zones, renewal price shown up front',
        'DNS editor and auto-renewal',
        'Transfer code any time',
      ],
      cta: 'Find a domain',
    },
    servers: {
      name: 'Servers',
      items: ['28 cities in 18 countries', 'Root access, Ubuntu or Debian', 'Monitoring and alerts included'],
      cta: 'Create a server',
    },
    sharedVpn: {
      name: 'VPN access',
      items: [
        'A ready-to-use VLESS key with no server setup',
        'Up to 2 devices and 100 GB for 30 days',
        'Works from Russia and can be tested for free',
      ],
      cta: 'Buy VPN access',
    },
    vpn: {
      name: 'Personal VPN',
      badge: '24 hours free',
      items: [
        'A separate server and stable IP just for you',
        'VLESS Reality for use under network blocking',
        'Your own panel and separate keys for family or team',
      ],
      cta: 'Try for free',
      secondaryCta: 'Create your own VPN',
    },
  },
  questions: 'Questions',
  faq: [
    [
      'How do I pay?',
      'Top up the balance in crypto through @CryptoBot or @xRocket: USDT, TON, BTC, ETH, LTC or TRX. The amount reaches the balance automatically, usually within a minute.',
    ],
    [
      'Who owns the domain?',
      'You manage it from your account: DNS, renewal and the transfer code to move it to another registrar whenever you like.',
    ],
    [
      'Which VPN should I choose?',
      'VLESS Reality works best where VPNs are blocked. AmneziaWG is fast and masked, Outline is the simplest, WireGuard suits countries without blocking.',
    ],
    [
      'Can I test the VPN before buying?',
      'Yes. After signing up, you get a personal VLESS key for 24 hours with 10 GB of traffic for up to two devices. You can then test speed and service availability on the public VPN status page.',
    ],
    [
      'How is my own VPN different from a regular VPN service?',
      'A regular VPN sells access to shared infrastructure, where many people use the same IP and resources. Uplink gives you a separate cloud server with a stable IP and your own panel. You control the keys, and traffic does not pass through shared Uplink VPN infrastructure.',
    ],
    [
      'Does the VPN work from Russia?',
      'For networks with blocking, we offer VLESS Reality, which disguises itself as regular HTTPS traffic. The status page shows the latest confirmed VPN check. Before buying, you can get a free 24-hour key and test it with your own Russian internet provider.',
    ],
    [
      'Can I connect my family or team?',
      'Yes. Create separate keys in your panel for different people and devices. The practical number of simultaneous connections depends on the server size and workload.',
    ],
    [
      'What happens if the balance runs out?',
      'We remind you in advance. An unpaid server stops and is deleted after three more days; topping up brings it back.',
    ],
    [
      'Can I use both the website and Telegram?',
      'Yes. Link Telegram in your profile and it is one account: the same balance, domains and servers in the browser, the bot and its Mini App.',
    ],
  ],
  ctaTitle: 'Start in a minute',
  ctaText: 'Create an account, top up and launch your first domain, server or VPN today.',
  createAccount: 'Create an account',
  openTelegram: 'Open in Telegram',
  footer: 'Domains, servers and VPN · payments in crypto via @CryptoBot and @xRocket',
  dashboard: {
    home: 'Home',
    domains: 'Domains',
    servers: 'Servers',
    balance: 'Balance',
    profile: 'Profile',
    greeting: 'Good evening, Anna',
    topUp: 'Top up',
    monthly: '$18.59 a month · lasts until March',
    cpu: 'CPU · web-prod',
    vpnReady: 'VPN ready',
    renews: 'Renews May 14, 2027',
    autoRenew: 'Auto-renew on',
    frankfurt: 'Frankfurt',
    amsterdam: 'Amsterdam',
  },
};

export const LANDING_TEXT: Record<Lang, typeof ru> = { ru, en };
